import { render, staticRenderFns } from "./AboutProductERP.vue?vue&type=template&id=1b86dec3"
import script from "./AboutProductERP.vue?vue&type=script&lang=js"
export * from "./AboutProductERP.vue?vue&type=script&lang=js"
import style0 from "./AboutProductERP.vue?vue&type=style&index=0&id=1b86dec3&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports